export var extractVisitUrl = function extractVisitUrl(jsonLd) {
  return jsonLd['atlassian:visitUrl'];
};